<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="localVisible" @close="close" @closed="reset">
    <div slot="title">{{ title }}</div>

    <div>
      <p>{{ $t('c.dialog.messageInputToList') }}</p>

      <v-multiple-input
        :placeholder="$t('c.dialog.placeholderEnterPlacementName')"
        :values.sync="domains"
        :filter="trimDomain"
        :validate="validateDomain"
      />
    </div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="close">{{ $t('c.dialog.buttonCancel') }}</v-button>
      <v-button theme="primary" @click="addPlacementsToListManually">{{ $t('c.dialog.buttonAdd') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VMultipleInput from '@/components/common/VMultipleInput.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import visibleMixin from '@/mixins/visible'
import { validateDomain } from '@/utils/common'

export default {
  name: 'VPlacementsDialogInput',

  components: {
    VMultipleInput,
    VRow
  },

  mixins: [visibleMixin],

  props: {
    type: {
      type: String,
      required: true,
      validator: (type) => {
        const availableTypes = [
          types.BLACKLIST_PLACEMENTS,
          types.WHITELIST_PLACEMENTS
        ]

        return availableTypes.includes(type)
      }
    },
    action: { type: String, required: true }
  },

  data() {
    return {
      domains: []
    }
  },

  computed: {
    title() {
      const titles = {
        [types.BLACKLIST_PLACEMENTS]: 'c.dialog.titleInputToBlackList',
        [types.WHITELIST_PLACEMENTS]: 'c.dialog.titleInputToWhiteList'
      }

      return this.$t(titles[this.type])
    }
  },

  methods: {
    reset() {
      this.domains = []
    },
    trimDomain(domain) {
      return domain.replace(
        /^(((https|http|ftp|rmtp|mms):)?\/\/)?(www\.)?/i,
        ''
      )
    },

    validateDomain(domain) {
      return validateDomain(domain)
    },

    addPlacementsToListManually() {
      this.close()
      const { domains, action } = this
      if (domains.length) {
        this.$store
          .dispatch(action, { domains })
          .then(() => this.$emit('change'))
      }
    }
  }
}
</script>
